<template>
  <full-screen-spinner v-if="isGated" />
  <router-view v-else />
</template>

<script setup>
import FullScreenSpinner from 'shared/components/FullScreenSpinner.vue';
import useDebounce from 'shared/composables/debounce';
import {
  computed, ref, watch,
} from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const routeNeedsHealing = computed(() => typeof route.name === 'string' && route.name.startsWith('legacy-'));

const { debounce, cancelAll } = useDebounce({ onBeforeUnmountCancel: true });
const gateTimedOut = ref(false);

watch(routeNeedsHealing, (needsHealing) => {
  cancelAll();

  gateTimedOut.value = false;
  if (needsHealing) {
    debounce(() => {
      gateTimedOut.value = true;
    }, 500);
  }
}, { immediate: true });

const isGated = computed(() => routeNeedsHealing.value && !gateTimedOut.value);
</script>
